import type {
  Exact,
  InputMaybe,
  RCatalogItems,
  RCreateCollection,
  RUpdateCollection,
  RUpdateCollectionItems,
  RLearningVisibility,
  RLearningType,
  RLearningStatus,
  Scalars as RemoteScalars,
} from './remote.gen';
type Scalars = Omit<RemoteScalars, 'JSON'> & { JSON: { input: unknown; output: unknown } };

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RCatalogJsonQueryVariables = Exact<{
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<RCatalogItems>> | InputMaybe<RCatalogItems>>;
}>;

export type RCatalogJsonQuery = { __typename?: 'Query'; catalog?: unknown | undefined };

export type RGetSavedLearningsQueryVariables = Exact<{ [key: string]: never }>;

export type RGetSavedLearningsQuery = {
  __typename?: 'Query';
  getMeta?:
    | { __typename?: 'UserMeta'; userId?: number | undefined; type?: string | undefined; meta?: unknown | undefined }
    | undefined;
};

export type RUpdateSavedLearningsMutationVariables = Exact<{
  meta: Scalars['JSON']['input'];
}>;

export type RUpdateSavedLearningsMutation = {
  __typename?: 'Mutation';
  updateMeta?:
    | { __typename?: 'UserMeta'; userId?: number | undefined; type?: string | undefined; meta?: unknown | undefined }
    | undefined;
};

export type RCatalogLearningCardFragment = {
  __typename?: 'LearningCard';
  id: string;
  entity: string;
  entityId: number;
  title: string;
  teaser?: string | undefined;
  language?: string | undefined;
  languageId?: number | undefined;
  image?: string | undefined;
  canEdit?: boolean | undefined;
  featured?: boolean | undefined;
  available?: boolean | undefined;
  type?: string | undefined;
  spaceId?: number | undefined;
  archived?: boolean | undefined;
  provider?: string | undefined;
  visibility?: RLearningVisibility | undefined;
  totalEffort?: number | undefined;
  level?: string | undefined;
  attributes?: unknown | undefined;
  subjects?:
    | Array<
        | {
            __typename?: 'LearningSubject';
            category?: string | undefined;
            categoryId?: number | undefined;
            subject?: string | undefined;
            subjectId?: number | undefined;
          }
        | undefined
      >
    | undefined;
  participation?:
    | {
        __typename?: 'Participation';
        progress: number;
        isCompleted: boolean;
        userEffort?: number | undefined;
        completedAt?: Date | undefined;
        expiredAt?: Date | undefined;
      }
    | undefined;
  locations?:
    | Array<
        | { __typename?: 'LearningCardLocation'; id: number; startDate?: string | undefined; endDate?: string | undefined }
        | undefined
      >
    | undefined;
};

export type RCatalogProductCardFragment = {
  __typename?: 'ProductCard';
  id: string;
  entity: string;
  entityId: number;
  title: string;
  teaser?: string | undefined;
  language?: string | undefined;
  languageId?: number | undefined;
  image?: string | undefined;
  canEdit?: boolean | undefined;
  featured?: boolean | undefined;
  available?: boolean | undefined;
  type?: string | undefined;
  spaceId?: number | undefined;
  archived?: boolean | undefined;
  provider?: string | undefined;
  visibility?: RLearningVisibility | undefined;
  totalEffort?: number | undefined;
  level?: string | undefined;
  format?: string | undefined;
  customLink?: string | undefined;
  isApprovalRequired?: boolean | undefined;
  state?: string | undefined;
  attributes?: unknown | undefined;
  objectId?: string | undefined;
  subjects?:
    | Array<
        | {
            __typename?: 'LearningSubject';
            category?: string | undefined;
            categoryId?: number | undefined;
            subject?: string | undefined;
            subjectId?: number | undefined;
          }
        | undefined
      >
    | undefined;
  participation?:
    | {
        __typename?: 'Participation';
        progress: number;
        isCompleted: boolean;
        userEffort?: number | undefined;
        completedAt?: Date | undefined;
        expiredAt?: Date | undefined;
      }
    | undefined;
};

export type RCatalogCollectionCardFragment = {
  __typename?: 'CollectionCard';
  id: string;
  entity: string;
  entityId: number;
  title: string;
  teaser?: string | undefined;
  language?: string | undefined;
  languageId?: number | undefined;
  image?: string | undefined;
  canEdit?: boolean | undefined;
  featured?: boolean | undefined;
  available?: boolean | undefined;
  type?: string | undefined;
  spaceId?: number | undefined;
  archived?: boolean | undefined;
  provider?: string | undefined;
  visibility?: RLearningVisibility | undefined;
  subjects?:
    | Array<
        | {
            __typename?: 'LearningSubject';
            category?: string | undefined;
            categoryId?: number | undefined;
            subject?: string | undefined;
            subjectId?: number | undefined;
          }
        | undefined
      >
    | undefined;
  participation?: { __typename?: 'Participation'; completedAt?: Date | undefined } | undefined;
};

export type RCatalogJourneyCardFragment = {
  __typename?: 'JourneyCard';
  id: string;
  entity: string;
  entityId: number;
  title: string;
  teaser?: string | undefined;
  language?: string | undefined;
  languageId?: number | undefined;
  image?: string | undefined;
  canEdit?: boolean | undefined;
  featured?: boolean | undefined;
  available?: boolean | undefined;
  type?: string | undefined;
  spaceId?: number | undefined;
  archived?: boolean | undefined;
  provider?: string | undefined;
  visibility?: RLearningVisibility | undefined;
  subjects?:
    | Array<
        | {
            __typename?: 'LearningSubject';
            category?: string | undefined;
            categoryId?: number | undefined;
            subject?: string | undefined;
            subjectId?: number | undefined;
          }
        | undefined
      >
    | undefined;
  participation?: { __typename?: 'Participation'; completedAt?: Date | undefined } | undefined;
};

export type RCollectionItemFragmentFragment = {
  __typename?: 'CollectionItemShort';
  productId?: number | undefined;
  learningId?: number | undefined;
  order?: number | undefined;
  visibility?: RLearningVisibility | undefined;
};

export type RCatalogItemsQueryVariables = Exact<{ [key: string]: never }>;

export type RCatalogItemsQuery = {
  __typename?: 'Query';
  catalog?:
    | {
        __typename?: 'Catalog';
        cards?:
          | Array<
              | {
                  __typename?: 'CollectionCard';
                  id: string;
                  spaceId?: number | undefined;
                  entity: string;
                  entityId: number;
                  title: string;
                  type?: string | undefined;
                }
              | {
                  __typename?: 'JourneyCard';
                  id: string;
                  spaceId?: number | undefined;
                  entity: string;
                  entityId: number;
                  title: string;
                  type?: string | undefined;
                }
              | {
                  __typename?: 'LearningCard';
                  id: string;
                  spaceId?: number | undefined;
                  entity: string;
                  entityId: number;
                  title: string;
                  type?: string | undefined;
                }
              | {
                  __typename?: 'ProductCard';
                  id: string;
                  spaceId?: number | undefined;
                  entity: string;
                  entityId: number;
                  title: string;
                  type?: string | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type RCatalogQueryVariables = Exact<{
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<RCatalogItems>> | InputMaybe<RCatalogItems>>;
}>;

export type RCatalogQuery = {
  __typename?: 'Query';
  catalog?:
    | {
        __typename?: 'Catalog';
        cards?:
          | Array<
              | {
                  __typename?: 'CollectionCard';
                  id: string;
                  entity: string;
                  entityId: number;
                  title: string;
                  teaser?: string | undefined;
                  language?: string | undefined;
                  languageId?: number | undefined;
                  image?: string | undefined;
                  canEdit?: boolean | undefined;
                  featured?: boolean | undefined;
                  available?: boolean | undefined;
                  type?: string | undefined;
                  spaceId?: number | undefined;
                  archived?: boolean | undefined;
                  provider?: string | undefined;
                  visibility?: RLearningVisibility | undefined;
                  items?:
                    | Array<
                        | {
                            __typename?: 'CollectionItemShort';
                            productId?: number | undefined;
                            learningId?: number | undefined;
                            order?: number | undefined;
                            visibility?: RLearningVisibility | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  subjects?:
                    | Array<
                        | {
                            __typename?: 'LearningSubject';
                            category?: string | undefined;
                            categoryId?: number | undefined;
                            subject?: string | undefined;
                            subjectId?: number | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  participation?: { __typename?: 'Participation'; completedAt?: Date | undefined } | undefined;
                }
              | {
                  __typename?: 'JourneyCard';
                  id: string;
                  entity: string;
                  entityId: number;
                  title: string;
                  teaser?: string | undefined;
                  language?: string | undefined;
                  languageId?: number | undefined;
                  image?: string | undefined;
                  canEdit?: boolean | undefined;
                  featured?: boolean | undefined;
                  available?: boolean | undefined;
                  type?: string | undefined;
                  spaceId?: number | undefined;
                  archived?: boolean | undefined;
                  provider?: string | undefined;
                  visibility?: RLearningVisibility | undefined;
                  subjects?:
                    | Array<
                        | {
                            __typename?: 'LearningSubject';
                            category?: string | undefined;
                            categoryId?: number | undefined;
                            subject?: string | undefined;
                            subjectId?: number | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  participation?: { __typename?: 'Participation'; completedAt?: Date | undefined } | undefined;
                }
              | {
                  __typename?: 'LearningCard';
                  id: string;
                  entity: string;
                  entityId: number;
                  title: string;
                  teaser?: string | undefined;
                  language?: string | undefined;
                  languageId?: number | undefined;
                  image?: string | undefined;
                  canEdit?: boolean | undefined;
                  featured?: boolean | undefined;
                  available?: boolean | undefined;
                  type?: string | undefined;
                  spaceId?: number | undefined;
                  archived?: boolean | undefined;
                  provider?: string | undefined;
                  visibility?: RLearningVisibility | undefined;
                  totalEffort?: number | undefined;
                  level?: string | undefined;
                  attributes?: unknown | undefined;
                  subjects?:
                    | Array<
                        | {
                            __typename?: 'LearningSubject';
                            category?: string | undefined;
                            categoryId?: number | undefined;
                            subject?: string | undefined;
                            subjectId?: number | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  participation?:
                    | {
                        __typename?: 'Participation';
                        progress: number;
                        isCompleted: boolean;
                        userEffort?: number | undefined;
                        completedAt?: Date | undefined;
                        expiredAt?: Date | undefined;
                      }
                    | undefined;
                  locations?:
                    | Array<
                        | {
                            __typename?: 'LearningCardLocation';
                            id: number;
                            startDate?: string | undefined;
                            endDate?: string | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                }
              | {
                  __typename?: 'ProductCard';
                  id: string;
                  entity: string;
                  entityId: number;
                  title: string;
                  teaser?: string | undefined;
                  language?: string | undefined;
                  languageId?: number | undefined;
                  image?: string | undefined;
                  canEdit?: boolean | undefined;
                  featured?: boolean | undefined;
                  available?: boolean | undefined;
                  type?: string | undefined;
                  spaceId?: number | undefined;
                  archived?: boolean | undefined;
                  provider?: string | undefined;
                  visibility?: RLearningVisibility | undefined;
                  totalEffort?: number | undefined;
                  level?: string | undefined;
                  format?: string | undefined;
                  customLink?: string | undefined;
                  isApprovalRequired?: boolean | undefined;
                  state?: string | undefined;
                  attributes?: unknown | undefined;
                  objectId?: string | undefined;
                  subjects?:
                    | Array<
                        | {
                            __typename?: 'LearningSubject';
                            category?: string | undefined;
                            categoryId?: number | undefined;
                            subject?: string | undefined;
                            subjectId?: number | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  participation?:
                    | {
                        __typename?: 'Participation';
                        progress: number;
                        isCompleted: boolean;
                        userEffort?: number | undefined;
                        completedAt?: Date | undefined;
                        expiredAt?: Date | undefined;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type RCreateCollectionMutationVariables = Exact<{
  input: RCreateCollection;
}>;

export type RCreateCollectionMutation = {
  __typename?: 'Mutation';
  createCollection?:
    | {
        __typename?: 'LearningCollection';
        id?: number | undefined;
        spaceId?: number | undefined;
        title?: string | undefined;
        teaser?: string | undefined;
        imageUrl?: string | undefined;
        categoryId?: number | undefined;
        subjectId?: number | undefined;
        type?: RLearningType | undefined;
        canEdit?: boolean | undefined;
        visibility?: RLearningVisibility | undefined;
        status?: RLearningStatus | undefined;
        languageId?: number | undefined;
        contentOwner?: number | undefined;
        created?: string | undefined;
        creator?: number | undefined;
        creatorEmail?: string | undefined;
        updated?: string | undefined;
        updatedByEmail?: string | undefined;
      }
    | undefined;
};

export type RUpdateCollectionMutationVariables = Exact<{
  input: RUpdateCollection;
}>;

export type RUpdateCollectionMutation = {
  __typename?: 'Mutation';
  updateCollection?:
    | {
        __typename?: 'LearningCollection';
        id?: number | undefined;
        spaceId?: number | undefined;
        title?: string | undefined;
        teaser?: string | undefined;
        imageUrl?: string | undefined;
        categoryId?: number | undefined;
        subjectId?: number | undefined;
        type?: RLearningType | undefined;
        canEdit?: boolean | undefined;
        visibility?: RLearningVisibility | undefined;
        status?: RLearningStatus | undefined;
        languageId?: number | undefined;
        contentOwner?: number | undefined;
        created?: string | undefined;
        creator?: number | undefined;
        creatorEmail?: string | undefined;
        updated?: string | undefined;
        updatedByEmail?: string | undefined;
      }
    | undefined;
};

export type RUpdateCollectionItemsMutationVariables = Exact<{
  input: RUpdateCollectionItems;
}>;

export type RUpdateCollectionItemsMutation = {
  __typename?: 'Mutation';
  updateCollectionItems?: { __typename?: 'LearningCollection'; id?: number | undefined } | undefined;
};

export type RLearningCollectionFragmentFragment = {
  __typename?: 'LearningCollection';
  id?: number | undefined;
  spaceId?: number | undefined;
  title?: string | undefined;
  teaser?: string | undefined;
  imageUrl?: string | undefined;
  categoryId?: number | undefined;
  subjectId?: number | undefined;
  type?: RLearningType | undefined;
  canEdit?: boolean | undefined;
  visibility?: RLearningVisibility | undefined;
  status?: RLearningStatus | undefined;
  languageId?: number | undefined;
  contentOwner?: number | undefined;
  created?: string | undefined;
  creator?: number | undefined;
  creatorEmail?: string | undefined;
  updated?: string | undefined;
  updatedByEmail?: string | undefined;
};

export type RLearningCollectionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type RLearningCollectionQuery = {
  __typename?: 'Query';
  learningCollection?:
    | {
        __typename?: 'LearningCollection';
        id?: number | undefined;
        spaceId?: number | undefined;
        title?: string | undefined;
        teaser?: string | undefined;
        imageUrl?: string | undefined;
        categoryId?: number | undefined;
        subjectId?: number | undefined;
        type?: RLearningType | undefined;
        canEdit?: boolean | undefined;
        visibility?: RLearningVisibility | undefined;
        status?: RLearningStatus | undefined;
        languageId?: number | undefined;
        contentOwner?: number | undefined;
        created?: string | undefined;
        creator?: number | undefined;
        creatorEmail?: string | undefined;
        updated?: string | undefined;
        updatedByEmail?: string | undefined;
        items?:
          | Array<
              | {
                  __typename?: 'CollectionCard';
                  id: string;
                  entity: string;
                  entityId: number;
                  title: string;
                  teaser?: string | undefined;
                  language?: string | undefined;
                  languageId?: number | undefined;
                  image?: string | undefined;
                  canEdit?: boolean | undefined;
                  featured?: boolean | undefined;
                  available?: boolean | undefined;
                  type?: string | undefined;
                  spaceId?: number | undefined;
                  archived?: boolean | undefined;
                  provider?: string | undefined;
                  visibility?: RLearningVisibility | undefined;
                  subjects?:
                    | Array<
                        | {
                            __typename?: 'LearningSubject';
                            category?: string | undefined;
                            categoryId?: number | undefined;
                            subject?: string | undefined;
                            subjectId?: number | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  participation?: { __typename?: 'Participation'; completedAt?: Date | undefined } | undefined;
                }
              | {
                  __typename?: 'JourneyCard';
                  id: string;
                  entity: string;
                  entityId: number;
                  title: string;
                  teaser?: string | undefined;
                  language?: string | undefined;
                  languageId?: number | undefined;
                  image?: string | undefined;
                  canEdit?: boolean | undefined;
                  featured?: boolean | undefined;
                  available?: boolean | undefined;
                  type?: string | undefined;
                  spaceId?: number | undefined;
                  archived?: boolean | undefined;
                  provider?: string | undefined;
                  visibility?: RLearningVisibility | undefined;
                  subjects?:
                    | Array<
                        | {
                            __typename?: 'LearningSubject';
                            category?: string | undefined;
                            categoryId?: number | undefined;
                            subject?: string | undefined;
                            subjectId?: number | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  participation?: { __typename?: 'Participation'; completedAt?: Date | undefined } | undefined;
                }
              | {
                  __typename?: 'LearningCard';
                  id: string;
                  entity: string;
                  entityId: number;
                  title: string;
                  teaser?: string | undefined;
                  language?: string | undefined;
                  languageId?: number | undefined;
                  image?: string | undefined;
                  canEdit?: boolean | undefined;
                  featured?: boolean | undefined;
                  available?: boolean | undefined;
                  type?: string | undefined;
                  spaceId?: number | undefined;
                  archived?: boolean | undefined;
                  provider?: string | undefined;
                  visibility?: RLearningVisibility | undefined;
                  totalEffort?: number | undefined;
                  level?: string | undefined;
                  attributes?: unknown | undefined;
                  subjects?:
                    | Array<
                        | {
                            __typename?: 'LearningSubject';
                            category?: string | undefined;
                            categoryId?: number | undefined;
                            subject?: string | undefined;
                            subjectId?: number | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  participation?:
                    | {
                        __typename?: 'Participation';
                        progress: number;
                        isCompleted: boolean;
                        userEffort?: number | undefined;
                        completedAt?: Date | undefined;
                        expiredAt?: Date | undefined;
                      }
                    | undefined;
                  locations?:
                    | Array<
                        | {
                            __typename?: 'LearningCardLocation';
                            id: number;
                            startDate?: string | undefined;
                            endDate?: string | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                }
              | {
                  __typename?: 'ProductCard';
                  id: string;
                  entity: string;
                  entityId: number;
                  title: string;
                  teaser?: string | undefined;
                  language?: string | undefined;
                  languageId?: number | undefined;
                  image?: string | undefined;
                  canEdit?: boolean | undefined;
                  featured?: boolean | undefined;
                  available?: boolean | undefined;
                  type?: string | undefined;
                  spaceId?: number | undefined;
                  archived?: boolean | undefined;
                  provider?: string | undefined;
                  visibility?: RLearningVisibility | undefined;
                  totalEffort?: number | undefined;
                  level?: string | undefined;
                  format?: string | undefined;
                  customLink?: string | undefined;
                  isApprovalRequired?: boolean | undefined;
                  state?: string | undefined;
                  attributes?: unknown | undefined;
                  objectId?: string | undefined;
                  subjects?:
                    | Array<
                        | {
                            __typename?: 'LearningSubject';
                            category?: string | undefined;
                            categoryId?: number | undefined;
                            subject?: string | undefined;
                            subjectId?: number | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  participation?:
                    | {
                        __typename?: 'Participation';
                        progress: number;
                        isCompleted: boolean;
                        userEffort?: number | undefined;
                        completedAt?: Date | undefined;
                        expiredAt?: Date | undefined;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export const CatalogLearningCardFragmentDoc = gql`
  fragment CatalogLearningCard on LearningCard {
    id
    entity
    entityId
    title
    teaser
    subjects {
      category
      categoryId
      subject
      subjectId
    }
    language
    languageId
    image
    canEdit
    featured
    available
    type
    spaceId
    archived
    provider
    visibility
    totalEffort
    level
    participation {
      progress
      isCompleted
      userEffort
      completedAt
      expiredAt
    }
    locations {
      id
      startDate
      endDate
    }
    attributes
  }
`;
export const CatalogProductCardFragmentDoc = gql`
  fragment CatalogProductCard on ProductCard {
    id
    entity
    entityId
    title
    teaser
    subjects {
      category
      categoryId
      subject
      subjectId
    }
    language
    languageId
    image
    canEdit
    featured
    available
    type
    spaceId
    archived
    provider
    visibility
    totalEffort
    level
    participation {
      progress
      isCompleted
      userEffort
      completedAt
      expiredAt
    }
    format
    customLink
    isApprovalRequired
    state
    attributes
    objectId
  }
`;
export const CatalogCollectionCardFragmentDoc = gql`
  fragment CatalogCollectionCard on CollectionCard {
    id
    entity
    entityId
    title
    teaser
    subjects {
      category
      categoryId
      subject
      subjectId
    }
    language
    languageId
    image
    canEdit
    featured
    available
    type
    spaceId
    archived
    provider
    visibility
    participation {
      completedAt
    }
  }
`;
export const CatalogJourneyCardFragmentDoc = gql`
  fragment CatalogJourneyCard on JourneyCard {
    id
    entity
    entityId
    title
    teaser
    subjects {
      category
      categoryId
      subject
      subjectId
    }
    language
    languageId
    image
    canEdit
    featured
    available
    type
    spaceId
    archived
    provider
    visibility
    participation {
      completedAt
    }
  }
`;
export const CollectionItemFragmentFragmentDoc = gql`
  fragment CollectionItemFragment on CollectionItemShort {
    productId
    learningId
    order
    visibility
  }
`;
export const LearningCollectionFragmentFragmentDoc = gql`
  fragment LearningCollectionFragment on LearningCollection {
    id
    spaceId
    title
    teaser
    imageUrl
    categoryId
    subjectId
    type
    canEdit
    visibility
    status
    languageId
    contentOwner
    created
    creator
    creatorEmail
    updated
    updatedByEmail
  }
`;
export const CatalogJsonDocument = gql`
  query catalogJson($showHidden: Boolean, $showArchived: Boolean, $items: [CatalogItems]) {
    catalog: catalogJSON(showHidden: $showHidden, showArchived: $showArchived, items: $items)
  }
`;

/**
 * __useCatalogJsonQueryRemote__
 *
 * To run a query within a React component, call `useCatalogJsonQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useCatalogJsonQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogJsonQueryRemote({
 *   variables: {
 *      showHidden: // value for 'showHidden'
 *      showArchived: // value for 'showArchived'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useCatalogJsonQueryRemote(baseOptions?: Apollo.QueryHookOptions<RCatalogJsonQuery, RCatalogJsonQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RCatalogJsonQuery, RCatalogJsonQueryVariables>(CatalogJsonDocument, options);
}
export function useCatalogJsonLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RCatalogJsonQuery, RCatalogJsonQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RCatalogJsonQuery, RCatalogJsonQueryVariables>(CatalogJsonDocument, options);
}
export type CatalogJsonQueryRemoteHookResult = ReturnType<typeof useCatalogJsonQueryRemote>;
export type CatalogJsonLazyQueryRemoteHookResult = ReturnType<typeof useCatalogJsonLazyQueryRemote>;
export type CatalogJsonQueryResult = Apollo.QueryResult<RCatalogJsonQuery, RCatalogJsonQueryVariables>;
export const GetSavedLearningsDocument = gql`
  query getSavedLearnings {
    getMeta(type: "SAVED_LEARNINGS") {
      userId
      type
      meta
    }
  }
`;

/**
 * __useGetSavedLearningsQueryRemote__
 *
 * To run a query within a React component, call `useGetSavedLearningsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedLearningsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedLearningsQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useGetSavedLearningsQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetSavedLearningsQuery, RGetSavedLearningsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetSavedLearningsQuery, RGetSavedLearningsQueryVariables>(GetSavedLearningsDocument, options);
}
export function useGetSavedLearningsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetSavedLearningsQuery, RGetSavedLearningsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetSavedLearningsQuery, RGetSavedLearningsQueryVariables>(GetSavedLearningsDocument, options);
}
export type GetSavedLearningsQueryRemoteHookResult = ReturnType<typeof useGetSavedLearningsQueryRemote>;
export type GetSavedLearningsLazyQueryRemoteHookResult = ReturnType<typeof useGetSavedLearningsLazyQueryRemote>;
export type GetSavedLearningsQueryResult = Apollo.QueryResult<RGetSavedLearningsQuery, RGetSavedLearningsQueryVariables>;
export const UpdateSavedLearningsDocument = gql`
  mutation updateSavedLearnings($meta: JSON!) {
    updateMeta(type: "SAVED_LEARNINGS", meta: $meta) {
      userId
      type
      meta
    }
  }
`;
export type RUpdateSavedLearningsMutationFn = Apollo.MutationFunction<
  RUpdateSavedLearningsMutation,
  RUpdateSavedLearningsMutationVariables
>;

/**
 * __useUpdateSavedLearningsMutationRemote__
 *
 * To run a mutation, you first call `useUpdateSavedLearningsMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedLearningsMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedLearningsMutationRemote, { data, loading, error }] = useUpdateSavedLearningsMutationRemote({
 *   variables: {
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useUpdateSavedLearningsMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpdateSavedLearningsMutation, RUpdateSavedLearningsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpdateSavedLearningsMutation, RUpdateSavedLearningsMutationVariables>(
    UpdateSavedLearningsDocument,
    options,
  );
}
export type UpdateSavedLearningsMutationRemoteHookResult = ReturnType<typeof useUpdateSavedLearningsMutationRemote>;
export type UpdateSavedLearningsMutationResult = Apollo.MutationResult<RUpdateSavedLearningsMutation>;
export type UpdateSavedLearningsMutationOptions = Apollo.BaseMutationOptions<
  RUpdateSavedLearningsMutation,
  RUpdateSavedLearningsMutationVariables
>;
export const CatalogItemsDocument = gql`
  query catalogItems {
    catalog(showHidden: true) {
      cards {
        id
        spaceId
        entity
        entityId
        title
        type
      }
    }
  }
`;

/**
 * __useCatalogItemsQueryRemote__
 *
 * To run a query within a React component, call `useCatalogItemsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useCatalogItemsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogItemsQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useCatalogItemsQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RCatalogItemsQuery, RCatalogItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RCatalogItemsQuery, RCatalogItemsQueryVariables>(CatalogItemsDocument, options);
}
export function useCatalogItemsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RCatalogItemsQuery, RCatalogItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RCatalogItemsQuery, RCatalogItemsQueryVariables>(CatalogItemsDocument, options);
}
export type CatalogItemsQueryRemoteHookResult = ReturnType<typeof useCatalogItemsQueryRemote>;
export type CatalogItemsLazyQueryRemoteHookResult = ReturnType<typeof useCatalogItemsLazyQueryRemote>;
export type CatalogItemsQueryResult = Apollo.QueryResult<RCatalogItemsQuery, RCatalogItemsQueryVariables>;
export const CatalogDocument = gql`
  query catalog($showHidden: Boolean, $showArchived: Boolean, $items: [CatalogItems]) {
    catalog(showHidden: $showHidden, showArchived: $showArchived, items: $items) {
      cards {
        ...CatalogLearningCard
        ...CatalogProductCard
        ...CatalogCollectionCard
        ...CatalogJourneyCard
        ... on CollectionCard {
          items {
            ...CollectionItemFragment
          }
        }
      }
    }
  }
  ${CatalogLearningCardFragmentDoc}
  ${CatalogProductCardFragmentDoc}
  ${CatalogCollectionCardFragmentDoc}
  ${CatalogJourneyCardFragmentDoc}
  ${CollectionItemFragmentFragmentDoc}
`;

/**
 * __useCatalogQueryRemote__
 *
 * To run a query within a React component, call `useCatalogQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useCatalogQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogQueryRemote({
 *   variables: {
 *      showHidden: // value for 'showHidden'
 *      showArchived: // value for 'showArchived'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useCatalogQueryRemote(baseOptions?: Apollo.QueryHookOptions<RCatalogQuery, RCatalogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RCatalogQuery, RCatalogQueryVariables>(CatalogDocument, options);
}
export function useCatalogLazyQueryRemote(baseOptions?: Apollo.LazyQueryHookOptions<RCatalogQuery, RCatalogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RCatalogQuery, RCatalogQueryVariables>(CatalogDocument, options);
}
export type CatalogQueryRemoteHookResult = ReturnType<typeof useCatalogQueryRemote>;
export type CatalogLazyQueryRemoteHookResult = ReturnType<typeof useCatalogLazyQueryRemote>;
export type CatalogQueryResult = Apollo.QueryResult<RCatalogQuery, RCatalogQueryVariables>;
export const CreateCollectionDocument = gql`
  mutation createCollection($input: CreateCollection!) {
    createCollection(payload: $input) {
      ...LearningCollectionFragment
    }
  }
  ${LearningCollectionFragmentFragmentDoc}
`;
export type RCreateCollectionMutationFn = Apollo.MutationFunction<RCreateCollectionMutation, RCreateCollectionMutationVariables>;

/**
 * __useCreateCollectionMutationRemote__
 *
 * To run a mutation, you first call `useCreateCollectionMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionMutationRemote, { data, loading, error }] = useCreateCollectionMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCollectionMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCreateCollectionMutation, RCreateCollectionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateCollectionMutation, RCreateCollectionMutationVariables>(CreateCollectionDocument, options);
}
export type CreateCollectionMutationRemoteHookResult = ReturnType<typeof useCreateCollectionMutationRemote>;
export type CreateCollectionMutationResult = Apollo.MutationResult<RCreateCollectionMutation>;
export type CreateCollectionMutationOptions = Apollo.BaseMutationOptions<
  RCreateCollectionMutation,
  RCreateCollectionMutationVariables
>;
export const UpdateCollectionDocument = gql`
  mutation updateCollection($input: UpdateCollection!) {
    updateCollection(payload: $input) {
      ...LearningCollectionFragment
    }
  }
  ${LearningCollectionFragmentFragmentDoc}
`;
export type RUpdateCollectionMutationFn = Apollo.MutationFunction<RUpdateCollectionMutation, RUpdateCollectionMutationVariables>;

/**
 * __useUpdateCollectionMutationRemote__
 *
 * To run a mutation, you first call `useUpdateCollectionMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMutationRemote, { data, loading, error }] = useUpdateCollectionMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCollectionMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpdateCollectionMutation, RUpdateCollectionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpdateCollectionMutation, RUpdateCollectionMutationVariables>(UpdateCollectionDocument, options);
}
export type UpdateCollectionMutationRemoteHookResult = ReturnType<typeof useUpdateCollectionMutationRemote>;
export type UpdateCollectionMutationResult = Apollo.MutationResult<RUpdateCollectionMutation>;
export type UpdateCollectionMutationOptions = Apollo.BaseMutationOptions<
  RUpdateCollectionMutation,
  RUpdateCollectionMutationVariables
>;
export const UpdateCollectionItemsDocument = gql`
  mutation updateCollectionItems($input: UpdateCollectionItems!) {
    updateCollectionItems(payload: $input) {
      id
    }
  }
`;
export type RUpdateCollectionItemsMutationFn = Apollo.MutationFunction<
  RUpdateCollectionItemsMutation,
  RUpdateCollectionItemsMutationVariables
>;

/**
 * __useUpdateCollectionItemsMutationRemote__
 *
 * To run a mutation, you first call `useUpdateCollectionItemsMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionItemsMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionItemsMutationRemote, { data, loading, error }] = useUpdateCollectionItemsMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCollectionItemsMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpdateCollectionItemsMutation, RUpdateCollectionItemsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpdateCollectionItemsMutation, RUpdateCollectionItemsMutationVariables>(
    UpdateCollectionItemsDocument,
    options,
  );
}
export type UpdateCollectionItemsMutationRemoteHookResult = ReturnType<typeof useUpdateCollectionItemsMutationRemote>;
export type UpdateCollectionItemsMutationResult = Apollo.MutationResult<RUpdateCollectionItemsMutation>;
export type UpdateCollectionItemsMutationOptions = Apollo.BaseMutationOptions<
  RUpdateCollectionItemsMutation,
  RUpdateCollectionItemsMutationVariables
>;
export const LearningCollectionDocument = gql`
  query learningCollection($id: Int!) {
    learningCollection(id: $id) {
      ...LearningCollectionFragment
      items {
        ...CatalogLearningCard
        ...CatalogProductCard
        ...CatalogCollectionCard
        ...CatalogJourneyCard
      }
    }
  }
  ${LearningCollectionFragmentFragmentDoc}
  ${CatalogLearningCardFragmentDoc}
  ${CatalogProductCardFragmentDoc}
  ${CatalogCollectionCardFragmentDoc}
  ${CatalogJourneyCardFragmentDoc}
`;

/**
 * __useLearningCollectionQueryRemote__
 *
 * To run a query within a React component, call `useLearningCollectionQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningCollectionQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCollectionQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningCollectionQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningCollectionQuery, RLearningCollectionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningCollectionQuery, RLearningCollectionQueryVariables>(LearningCollectionDocument, options);
}
export function useLearningCollectionLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningCollectionQuery, RLearningCollectionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningCollectionQuery, RLearningCollectionQueryVariables>(LearningCollectionDocument, options);
}
export type LearningCollectionQueryRemoteHookResult = ReturnType<typeof useLearningCollectionQueryRemote>;
export type LearningCollectionLazyQueryRemoteHookResult = ReturnType<typeof useLearningCollectionLazyQueryRemote>;
export type LearningCollectionQueryResult = Apollo.QueryResult<RLearningCollectionQuery, RLearningCollectionQueryVariables>;
